export default "__VITE_ASSET__D0CSGZ27__"